<template>
  <section class="faq-list bg-gray-20">
    <div class="container mx-auto bg-white rounded pt-4 pb-5">
      <h2 class="text-xl py-3 px-5">{{ $t('category_faq_title') }}</h2>
      <nd-collapse :list="faqs" :divider="true"></nd-collapse>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { CategoryDetailData } from '@/types/api'

const props = defineProps<{
  category: CategoryDetailData
}>()

const faqs = computed(
  () =>
    props.category?.faq_list?.map(item => ({
      title: item.question || '',
      content: item.answer || '',
    })) || []
)
</script>

<style lang="scss" scoped>
.faq-list {
}
</style>
